import { FC } from 'react';
import { Button, darkV2Theme, Group, InlineNotification, Text } from '@logz-ui/styleguide';
import styled from 'styled-components';
import { useIsNewAppEnabled } from 'ui/hooks/is-new-application-enabled.hook';
import { analyticsService } from 'services/analytics/analytics.service';

const InnerBanner = styled(InlineNotification)`
  align-self: center;
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => (theme.name === darkV2Theme.name ? '#194185' : '#D1E9FF')};
  div {
    align-items: center;
    width: fit-content;
  }
`;

export const TemporaryModeBanner: FC = () => {
  const { isNewAppEnabled } = useIsNewAppEnabled();
  const onClick = () => {
    analyticsService.capture('Open 360 application migration', 'Clicked on Go to Open360AI from temporary mode banner');
    window.location.replace('/360/');
  };

  if (!isNewAppEnabled) return null;

  return (
    <InnerBanner
      variant={'info'}
      title={
        <Group justifyContent={'center'} alignItems={'center'}>
          <Text>You’re viewing the previous Logz.io experience</Text>
          <Button onClick={onClick} size={'s'} variant={'secondary'}>
            Go to Open 360 AI
          </Button>
        </Group>
      }
      noClose
      fullWidth
    />
  );
};
